module.exports = __webpack_public_path__ + "static/img/strategy-man.3338fe7d.png";